import { _lang } from '@umu/ukit-lang';
import { lang } from '@umu/ukit-lang';
/**
 * @description 选中浮层
 * @author duanjun
 */

import React, { Component } from 'react';

import './selectionMenu.scss';

import { components } from 'common';
const { If } = components;
import { $document, $window, contains } from '@umu/umu-dom';
import { debounce, throttle } from '@umu/umu-util';

const clickEventType = document.ontouchstart !== null ? 'click' : 'touchstart';

export interface ICommentData {
    content: string;
    quote: string;
}

interface IProps {
    checkStudentInfo(): boolean;
    docCommentNote(comment: ICommentData, index: number): void;
    composeNote(): void;
}
interface IState {
    showDialog: boolean;
    top: number;
    left: number;
    arrowClassName: string;
}

class SelectionMenu extends Component<IProps, IState> {
    public selectedText: string;
    constructor(props: IProps) {
        super(props);
        this.state = {
            showDialog: false,
            top: 0,
            left: 0,
            arrowClassName: 'toward-up',
        };
        this.selectedText = '';
        this.onSelectionChange = debounce(this.onSelectionChange.bind(this), 80);
        this.onShare = this.onShare.bind(this);
        this.onCopy = this.onCopy.bind(this);
        this.onNote = this.onNote.bind(this);
        this.onScroll = throttle(this.onScroll.bind(this), 100);
    }

    public setPosition(pos: DOMRect | ClientRect) {
        const winWidth = $window.innerWidth;
        const winHeight = $window.innerHeight;
        let menuWidth = 100;
if(_lang("JP")) {
        menuWidth = 140;
}
if(_lang("EN")) {
        menuWidth = 140;
}
        const menuHeight = 54;
        let arrowClassName = 'toward-up';
        // 避免出右边界
        const left = Math.min(pos.left, winWidth - menuWidth);
        let top = pos.top;
        // 避免下边界出
        if (winHeight - pos.bottom < menuHeight) {
            top = top - 2 * menuHeight;
            arrowClassName = 'toward-down';
        } else {
            top = pos.bottom + 10; // 10 padding
        }
        this.setState({
            top,
            left,
            arrowClassName,
        });
    }

    public onSelectionChange() {
        const range = this.getRange();
        if (!range || !this.getSelectionText()) {
            this.close();
            return;
        }
        const docMainContent = $document.querySelector('.j_article-selection-container');
        const selectionContainer = range.commonAncestorContainer;
        // 不在文档区域内选择无效
        if (!contains(docMainContent, selectionContainer)) {
            return;
        }
        this.selectedText = this.getSelectionText();
        if (this.selectedText) {
            this.open();
        }
        const clientRects = range.getBoundingClientRect();
        this.setPosition(clientRects);
    }

    public onScroll() {
        this.onSelectionChange();
    }

    public getRange(): Range | undefined {
        interface IIEDocument extends Document {
            selection: {
                createRange(): Range | undefined;
            };
        }
        const doc = $document as IIEDocument;
        if ($window.getSelection) {
            const selection = $window.getSelection();
            if (selection && selection.rangeCount) {
                // @ts-ignore
                return $window.getSelection().getRangeAt(0);
            }
        } else if (doc.selection && doc.selection.createRange) {
            // 如果是IE
            return doc.selection.createRange();
        }
        return;
    }

    public getSelectionText() {
        const range = this.getRange();
        if (range) {
            return range.toString();
        } else {
            return '';
        }
    }

    public componentDidMount() {
        document.addEventListener('selectionchange', this.onSelectionChange, false);
        window.addEventListener('scroll', this.onScroll, false);
    }

    public componentWillUnmount() {
        document.removeEventListener('selectionchange', this.onSelectionChange, false);
        window.removeEventListener('scroll', this.onScroll, false);
    }

    public onCopy() {
        // 不做
    }

    public onShare() {
        // 不做
    }

    public onNote(event: React.TouchEvent<HTMLAnchorElement> | React.MouseEvent<HTMLAnchorElement>) {
        if (!this.props.checkStudentInfo()) {
            return;
        }
        // 避免执行两次
        if (clickEventType !== event.nativeEvent.type) {
            return;
        }
        const text = this.selectedText;
        this.props.docCommentNote(
            {
                quote: text,
                content: '',
            },
            -1,
        );
        this.props.composeNote();
        this.close();
    }

    public close() {
        if (!this.state.showDialog) {
            return;
        }
        this.setState({
            showDialog: false,
        });
    }

    public open() {
        if (!this.state.showDialog) {
            this.setState({
                showDialog: true,
            });
        }
    }

    public render() {
        const state = this.state;
        const menuStyle = {
            top: state.top,
            left: state.left,
        };

        const arrowClassName = 'arrow ' + this.state.arrowClassName;
        return (
            <If condition={this.state.showDialog}>
                <div className="selection-menu-dialog clearfix" style={menuStyle}>
                    <span className={arrowClassName}></span>
                    <a className="link link-note" onTouchStart={this.onNote} onClick={this.onNote} href="javascript:;">
                        {lang('记笔记')}
                    </a>
                </div>
            </If>
        );
    }
}

export default SelectionMenu;
